export default __webpack_public_path__ + "static/media/malujeme-si.4cf382f1.svg";